import { KindergartenRoleEnum } from "@king-ict/eupisi-ui/models";
import { Redirect, Route } from "react-router";

import { useCurrentUser } from "../hooks/authorization/useCurrentUser";

interface Props {
  path: string;
  exact?: boolean;
  component: any;
}

export const ParentRoute = ({ path, exact, component: Component }: Props) => {
  const user = useCurrentUser();

  return (
    <Route
      exact={exact}
      path={path}
      render={(props) =>
        user.roleId === KindergartenRoleEnum.Parent ? (
          <Component />
        ) : (
          <>
            {user.roleId === 0 ? <></> : <Redirect to="/page-not-available" />}
          </>
        )
      }
    />
  );
};
